export default [
  {
    meta: {
      is_auth: true,
      is_admin: true,
      title: "society",
      layout: "dashboard",
    },
    path: "/deposits",
    name: "deposits",
    component: () => import("@/layouts/index/DepositIndex.vue"),
    children: [
      {
        meta: {
          is_auth: true,
          is_admin: true,
          title: "Chambres froides",
          layout: "dashboard",
        },
        path: "coldrooms/index",
        name: "cold-rooms-index",
        component: () => import("@/views/cold_rooms/Listing.vue"),
      },
      {
        meta: {
          is_auth: true,
          is_admin: true,
          title: "Chambres froides",
          layout: "dashboard",
        },
        path: "coldrooms/create",
        name: "cold-rooms-create",
        component: () => import("@/views/cold_rooms/Create.vue"),
      },
      {
        meta: {
          is_auth: true,
          is_admin: true,
          title: "Températures de chambres froide",
          layout: "dashboard",
        },
        path: "coldrooms/:reference/temperatures",
        name: "cold-rooms-temperatures",
        component: () => import("@/views/cold_rooms/Temperatures.vue"),
      },
      {
        meta: {
          is_auth: true,
          is_admin: true,
          title: "Dépôts",
          layout: "dashboard",
        },
        path: "deposits/index",
        name: "deposits-index",
        component: () => import("@/views/deposits/Listing.vue"),
      },
      {
        meta: {
          is_auth: true,
          is_admin: true,
          title: "Créer un dépôts",
          layout: "dashboard",
        },
        path: "deposits/create",
        name: "deposits-create",
        component: () => import("@/views/deposits/Create.vue"),
      },
    ],
  },
];
